import { Suspense } from 'react'
import { useParams, Link } from 'react-router-dom'
import { getToolBySlug } from '../tools/registry'
import './ToolView.css'

export function ToolView() {
  const { slug } = useParams()
  const tool = getToolBySlug(slug)

  if (!tool) {
    return (
      <div className="tool-view">
        <div className="tool-not-found">
          <h2>Tool not found</h2>
          <p>The tool "{slug}" does not exist.</p>
          <Link to="/dashboard" className="btn btn-primary">Back to Dashboard</Link>
        </div>
      </div>
    )
  }

  const ToolComponent = tool.component

  return (
    <div className="tool-view">
      <div className="tool-toolbar">
        <div className="tool-toolbar-content container">
          <Link to="/dashboard" className="btn btn-ghost btn-sm tool-back-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Back
          </Link>
          <h1 className="tool-title">{tool.name}</h1>
        </div>
      </div>
      <main className="tool-content">
        <Suspense fallback={<div className="page-loading"><div className="spinner" /></div>}>
          <ToolComponent />
        </Suspense>
      </main>
    </div>
  )
}
